var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page flex-col"},[_c('div',{staticClass:"backBtn"},[_c('img',{attrs:{"src":require("@/assets/icon/back.png")},on:{"click":function($event){return _vm.$router.back()}}})]),_c('img',{staticClass:"signSuccess",attrs:{"src":require("@/assets/images/signSuccess.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }